module.exports = __webpack_public_path__ + "img/icon-play.6e473743.svg";